import { render } from "./resetPassword.vue?vue&type=template&id=662008d0&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=662008d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662008d0"]])

export default __exports__